/**
 * decides if the `childNode` is an instance of the `Element`
 */
export const isElement = (childNode: ChildNode | undefined): childNode is Element => {
  return childNode instanceof Element
}
